<template>
  <component
    ref="root"
    class="ButtonBase"
    :is="is"
    v-bind="$attrs"
    v-on="$listeners"
    @mouseleave="handleMouseLeave"
    @mousedown="handleMouseDown"
    @mouseup="handleMouseUp">
    <slot />
  </component>
</template>

<script>

export default {
  name: 'ButtonBase',

  props: {
    component: {
      type: [ String, Object ],
      default: 'button'
    }
  },

  data () {
    return {
      longClickIntervalId: null,
      longClickIntervalStartTimeoutId: null,
      isClicking: false
    }
  },

  computed: {
    is () { 
      if (this.$attrs.to) { return 'router-link' }
      
      return this.component
    }
  },

  methods: {
    emitLongClick (mouseDownEvent) {
      this.$emit('longclick', mouseDownEvent)
    },

    startLongClickInterval (mouseDownEvent) {
      if (this.isClicking) {
        this.longClickIntervalId = setInterval(
          this.emitLongClick.bind(this, mouseDownEvent),
          100
        )
      }
    },

    handleMouseLeave () {
      this.clearSchedules()

      this.isClicking = false
    },

    handleMouseDown (mouseDownEvent) {
      this.isClicking = true

      this.longClickIntervalStartTimeoutId = setTimeout(
        this.startLongClickInterval.bind(this, mouseDownEvent),
        500
      )
    },

    handleMouseUp () {
      this.clearSchedules()

      this.isClicking = false
    },

    clearSchedules () {
      if (this.longClickIntervalId) {
        clearInterval(this.longClickIntervalId)
      }

      if (this.longClickIntervalStartTimeoutId) {
        clearTimeout(this.longClickIntervalStartTimeoutId)
      }
    }
  }
}

</script>

<style scoped>

.ButtonBase { cursor: pointer; }

</style>
